const Types = {
  DATE_DID_CHANGE: '[DATE] DID CHANGE', // accion global
};

export default Types;